import Background from './modules/background';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <Background/>
  );
}

export default App;